import type { CurrentRefinementsConnectorParamsRefinement } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';
import { ALGOLIA_ATTRIBUTES } from '@shared/utils/src/algolia/algoliaAttributes';
import type { AlgoliaAttributeValue } from '@shared/utils/src/algolia/algoliaAttributes';
import { getBaseAttribute } from '../../../../../utils/algoliaFilterUtils/getBaseAttribute';

const attributeLabelMap: Partial<Record<AlgoliaAttributeValue, string>> = {
  [ALGOLIA_ATTRIBUTES.BRAND]: 'filter.menu.filter.brand',
  [ALGOLIA_ATTRIBUTES.PRODUCT_SUB_TYPES]: 'filter.menu.filter.style',
  [ALGOLIA_ATTRIBUTES.UPPER_MATERIAL]: 'filter.menu.filter.material',
  [ALGOLIA_ATTRIBUTES.FIT]: 'filter.menu.filter.width',
  [ALGOLIA_ATTRIBUTES.REVIEW_RATING]: 'filter.menu.filter.top.rated',
  [ALGOLIA_ATTRIBUTES.GENDER]: 'filter.menu.filter.gender',
  [ALGOLIA_ATTRIBUTES.PRODUCT_TYPE]: 'filter.menu.filter.product.type',
  [ALGOLIA_ATTRIBUTES.FASTENING]: 'filter.menu.filter.fastening',
  [ALGOLIA_ATTRIBUTES.HEEL_HEIGHT_GROUPS]: 'filter.menu.filter.heel.height',
  [ALGOLIA_ATTRIBUTES.TECHNOLOGIES]: 'filter.menu.filter.technology',
  [ALGOLIA_ATTRIBUTES.SIZE]: 'filter.menu.filter.size',
  [ALGOLIA_ATTRIBUTES.COLOR]: 'filter.menu.filter.colour',
};

export function createRefinementLabel(
  attribute: CurrentRefinementsConnectorParamsRefinement['attribute'],
  value: CurrentRefinementsConnectorParamsRefinement['value'],
) {
  const baseAttribute = getBaseAttribute(attribute);
  const entry = Object.entries(attributeLabelMap).find(([key]) => key === baseAttribute);

  if (entry) {
    const [key, label] = entry;
    return {
      label,
      value: key === ALGOLIA_ATTRIBUTES.SIZE ? value.toString().split('_')[0] : value,
    };
  }

  return {
    label: '',
    value,
  };
}
